module.exports = "/images/img4.png?0be7302f4e06f4951551a590f1cf1215";